import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
 {
 q: "How many guests can the Magic catamaran hold for a Sydney Harbour cruise?",
 a: "The Magic catamaran is fully licensed to host up to 100 guests, making it the perfect size for intimate weddings, corporate events, milestone birthdays and private parties on Sydney Harbour. We typically recommend 60, 90 guests for a comfortable seated dining experience and up to 100 for stand-up cocktail style events.",
 },
 {
 q: "Where does Magic Cruises depart from on Sydney Harbour?",
 a: "Our primary embarkation point is King Street Wharf, Darling Harbour, a 5-minute walk from Wynyard, Town Hall and Darling Harbour parking. We can also depart from Circular Quay, Rose Bay, Manly or any private wharf on Sydney Harbour by request.",
 },
 {
 q: "What's included in a Sydney Harbour charter on the Magic?",
 a: "Every charter includes the exclusive use of the Magic catamaran with two full decks, professional skipper and crew, NSW Maritime safety equipment, fully licensed onboard bar, climate-controlled lower deck and open-air upper deck. Catering, beverage packages, DJ and photography are available as add-ons.",
 },
 {
 q: "Can we cruise past the Sydney Opera House and Harbour Bridge?",
 a: "Yes, every Magic charter is fully customisable and routes are designed around your group. The most popular route glides past the Sydney Opera House, under the Sydney Harbour Bridge, around Fort Denison and Shark Island, with optional stops at Watsons Bay, Manly or Rose Bay.",
 },
 {
 q: "Do you offer wedding cruises on Sydney Harbour?",
 a: "Yes. Magic Cruises is one of Sydney's most popular wedding harbour cruise venues. We host ceremonies under the Harbour Bridge, golden-hour cocktail receptions and full sit-down reception cruises with onboard catering and bar service. Wedding packages start from $7,500 for a 4-hour exclusive charter.",
 },
 {
 q: "How much does it cost to charter Magic Cruises?",
 a: "Private charter pricing starts at $1,750 per hour with a minimum 3-hour booking. Total cost depends on guest numbers, catering, beverage packages and the date, NYE, Vivid Sydney and December bookings are premium-priced. Visit our Packages page or request a custom quote.",
 },
 {
 q: "Can I bring my own food and drinks (BYO)?",
 a: "Yes, we offer fully BYO charters which let you bring your own catering and beverages. BYO is one of the most affordable ways to charter the Magic, especially for buck's parties, hen's parties and casual celebrations. A modest service fee and corkage applies.",
 },
 {
 q: "Do you cruise during NYE and Vivid Sydney?",
 a: "Absolutely, Magic Cruises is a regular participant in the famous NYE Sydney Harbour Light Parade with front-row seats to the 9pm and midnight fireworks. We also run nightly Vivid Sydney light cruises during the festival (May 23, June 14). Both sell out 6+ months in advance.",
 },
];

export default function FAQSection() {
 const [open, setOpen] = useState(0);

 // JSON-LD FAQPage schema for SEO
 const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": FAQS.map((f) => ({
   "@type": "Question",
   "name": f.q,
   "acceptedAnswer": { "@type": "Answer", "text": f.a }
  }))
 };

 return (
 <section className="relative mx-auto max-w-3xl px-5 lg:px-10 py-24 lg:py-32" data-testid="faq-section">
  <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
 <div className="text-center">
 <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.32em] font-bold text-pink uppercase">
 <span className="w-6 h-px bg-pink/60" /> FAQs <span className="w-6 h-px bg-pink/60" />
 </div>
 <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-ink mt-5 leading-[1.05]" data-testid="faq-headline">
 Everything you need <em className="italic font-light text-pink block">to know.</em>
 </h2>
 </div>

 <div className="mt-12 space-y-3" data-testid="faq-list">
 {FAQS.map((item, i) => {
 const isOpen = open === i;
 return (
 <div
 key={i}
 className={`rounded-2xl bg-white ring-1 transition-all overflow-hidden ${isOpen ? "ring-pink/30 shadow-lg" : "ring-[hsl(220,18%,88%)] shadow-sm"}`}
 data-testid={`faq-item-${i}`}
 >
 <button
 type="button"
 onClick={() => setOpen(isOpen ? -1 : i)}
 className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left"
 aria-expanded={isOpen}
 data-testid={`faq-toggle-${i}`}
 >
 <span className="font-bold text-ink text-base md:text-lg leading-snug">{item.q}</span>
 <span className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-all ${isOpen ? "bg-pink text-white" : "bg-pink/15 text-pink"}`}>
 {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
 </span>
 </button>
 <div
 className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
 >
 <div className="overflow-hidden">
 <p className="px-6 pb-6 text-ink-soft text-sm md:text-base leading-relaxed">{item.a}</p>
 </div>
 </div>
 </div>
 );
 })}
 </div>
 </section>
 );
}
